var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBellIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 13.3 11.81",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{clip-path:url(#clip-path);}.cls-3,.cls-4{fill:#1c3152;}.cls-3{fill-rule:evenodd;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 13.3,
    height: 11.81
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Untitled-1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M13.11,2.58a1.47,1.47,0,0,0-2-.61l1.39,2.6a1.47,1.47,0,0,0,.61-2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M12.8,6.53,9.63.73A1.25,1.25,0,0,0,8.08.2a1.17,1.17,0,0,0-.64.67L3.5,5h0a1.41,1.41,0,0,0-1,0l-.64.25a1.26,1.26,0,0,0-.69.63,2,2,0,0,0-.09.33l-.36.13a.84.84,0,0,0-.49.45.76.76,0,0,0,0,.66L.89,8.94a.89.89,0,0,0,.49.46.91.91,0,0,0,.67,0l.39-.14a1.36,1.36,0,0,0,.41.26,1.74,1.74,0,0,0,.29.07,6.09,6.09,0,0,0,.25.83,2.92,2.92,0,0,0,.83,1.05l.16.13.27,0h.14a1.26,1.26,0,0,0,1.3-.75l.11-.33L6,10.29c-.11-.12-.43-.49-.56-.68a3.58,3.58,0,0,1-.26-.81l0-.12,0,0,0,0,6.19-.47a1.32,1.32,0,0,0,.94,0,1.1,1.1,0,0,0,.65-.81,1.2,1.2,0,0,0-.13-.78M5.41,10.65l0,0h0ZM1.73,8.59,1.07,7.12,1.32,7,2,8.5Zm2.56-.51c0,.07.07.17,0,.21s-.7.35-.91.44a.33.33,0,0,1-.22,0A.57.57,0,0,1,3,8.54C2.76,8,2,6.34,2,6.34A.28.28,0,0,1,2.22,6l.63-.25a.39.39,0,0,1,.48.17c.13.38,1,2.14,1,2.14m.83,2.62a1,1,0,0,1-.36.06,2.1,2.1,0,0,1-.51-.63A5.64,5.64,0,0,1,4,9.43l.29-.11a3.17,3.17,0,0,0,.31.78,7,7,0,0,0,.48.6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellIcon);
export default __webpack_public_path__ + "static/media/bell-icon.f44637e0b6b6fd908027983604b64823.svg";
export { ForwardRef as ReactComponent };